<template>
  <div data-component="map">
    <div class="map__container">
      <img :src="data.src" :alt="data.alt" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'component_map',
  props: ['data'],
};
</script>

<style lang="scss">
[data-component="map"] {
  img {
    max-width: 100%;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/map.vue